@import '../../../../../../constants/spacing.module.less';

.modal-body {
  padding: @space-16;
}

.description {
  margin-bottom: @space-12;
}

.address-section {
  margin-bottom: @space-16;
}

.address-label {
  margin-bottom: @space-4;
}

.address-display {
  color: var(--grey-600);
}

.reference-order-section {
  margin-bottom: @space-8;
}

.reference-order-label {
  margin-bottom: @space-4;
}
